// extracted by mini-css-extract-plugin
module.exports = {"inputContianer":"InventorySearch_inputContianer__2qaAN","input":"InventorySearch_input__2AHS2"};